<template>
  <div v-if="isMobileSearchBarOpen" class="searchMobileModal">
    <div class="close-btn" @click="toggleMobileMenu(false)"><i class="owl-status-error"></i></div>
    <div>
      <searchPlaceInput ref="mobileSearchPlaceInput" style="min-width: 100%;" isInline/>
      <searchDatePicker ref="mobileSearchDatePicker" class="lg:block" style="min-width: 250px;" isInline/>
      <searchPeoplePicker ref="mobileSearchPeoplePicker" class="lg:block" style="min-width: 220px;" isInline/>
      <div>
        <button class="btn btn-block btn-solid btn-blue-light" @click.stop="submitSearchData">{{ $t('search') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Modal from './index.js'
// import SimpleVueValidation from 'simple-vue-validator'

// import searchWarningModal from '@/components/modals/searchWarningModal'

import searchActions from '@/mixins/searchActions'

// const Validator = SimpleVueValidation.Validator

export default {
  name: 'searchMobileModal',
  mixins: [
    searchActions
  ],
  props: {
  },
  components: {
  },
  // validators: {
  //   'start': function (val) {
  //     if (typeof val === 'undefined') {
  //       val = null
  //     }
  //     return Validator.value(val).required()
  //   },
  //   'end': function (val) {
  //     if (typeof val === 'undefined') {
  //       val = null
  //     }
  //     return Validator.value(val).required()
  //   }
  // },
  data () {
    return {
      isInitializing: true
    }
  },
  computed: {
    ...mapGetters({
      isMobileSearchBarOpen: 'user/isMobileSearchBarOpen'
    })
  },
  methods: {
    ...mapActions([
      'bodyLock'
    ]),
    ...mapMutations([
      'user/MOBILE_SEARCH_BAR_STATUS'
    ]),
    toggleMobileMenu: function (bool) {
      const toggleBool = typeof bool === 'boolean' ? bool : !this.isMobileSearchBarOpen
      this['user/MOBILE_SEARCH_BAR_STATUS'](toggleBool)
    },
    doValidate: async function () {
      let form = {}
      let errors = []
      await this.validateSearchPlaceInput().then(res => {
        form.search = res
      }).catch(err => {
        errors.push('searchPlaceInput')
        console.error(err)
        throw Error('searchPlaceInput is not filled.')
      })
      await this.validateSearchDatePicker().then(res => {
        form.date = res
      }).catch(err => {
        errors.push('searchDatePicker')
        console.error(err)
        throw Error('searchDatePicker is not filled.')
      })
      await this.validateSearchPeoplePicker().then(res => {
        form.people = res
      }).catch(err => {
        errors.push('searchPeoplePicker')
        console.error(err)
        throw Error('searchPeoplePicker is not filled.')
      })

      // If all validations passed
      if (errors.length > 0) {
        const errMsg = []
        for (const err of errors) {
          errMsg.push(this.$t(err))
        }
        return Promise.reject(errMsg)
      } else {
        return form
      }
    },
    validateSearchPlaceInput: function () {
      return this.$refs.mobileSearchPlaceInput.doValidate().then(res => {
        if (res) {
          return res
        }
      }, err => {
        return Promise.reject(err)
      })
    },
    validateSearchDatePicker: function () {
      return this.$refs.mobileSearchDatePicker.doValidate().then(res => {
        if (res) {
          return res
        }
      }, err => {
        return Promise.reject(err)
      })
    },
    validateSearchPeoplePicker: function () {
      return this.$refs.mobileSearchPeoplePicker.doValidate().then(res => {
        if (res) {
          return res
        }
      }, err => {
        return Promise.reject(err)
      })
    },
    submitSearchData: async function () {
      console.debug('submitSearchData')
      this.doValidate().then(res => {
        const form = res
        console.debug('form', form)
        this._onClickSearchButton(form)
        this.toggleMobileMenu(false)
      }).catch(err => {
        const errMsg = err
        console.debug('errMsg', errMsg)
        this.toggleMobileMenu(true)
      })
    },
    setDataToChild: function (payload) {
      console.debug('setDataToChild', payload)
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.mobileSearchPlaceInput.inputValue = payload.inputValue
          this.$refs.mobileSearchPlaceInput.selected = payload.selected
          this.$refs.mobileSearchPlaceInput.list = payload.list
        }, 300)
      })
    }
  },
  created () {
  },
  mounted () {
  },
  beforeMount () {
    Modal.event.$on('toggle', this.toggleMobileMenu)
    Modal.event.$on('set', this.setDataToChild)
    Modal.event.$on('submit', this.submitSearchData)
    // Modal.event.$on('focus', this.focusTo)
  },
  beforeDestroy () {
    Modal.event.$off('toggle', this.toggleMobileMenu)
    Modal.event.$off('set', this.setDataToChild)
    Modal.event.$off('submit', this.submitSearchData)
    // Modal.event.$off('focus', this.focusTo)
  },
  watch: {
    '$route' () {
      this['user/MOBILE_SEARCH_BAR_STATUS'](false)
    },
    'isMobileSearchBarOpen' (val) {
      this.bodyLock(val)
    }
  }
}
</script>

<style lang="sass" scoped>
.searchMobileModal
  @apply fixed pin-t pin-l bg-white z-999 w-full h-full p-8 overflow-auto
  .close-btn
    @apply flex items-center justify-end text-3xl
  select
    @apply px-8 py-16 text-grey-darker text-base my-8
    background: url('~@/assets/dropdown.svg') no-repeat right #f2f4f6
    -webkit-appearance: none
    background-position-x: calc(100% - 16px)
</style>
